import { css } from "styled-components";

import {
    FONT_FAMILY_DISPLAY,
    FONT_FAMILY_TEXT,
    FONT_FAMILY_SYSTEM
} from "./constants";
import { h1, h2, h3, h4, h5, h6 } from "./headings";
import { redundantCssFromKebab } from "./redundant-css";
import { fontSizes } from "./textSize";
import { theme } from "./theme";

export const elements: ReturnType<typeof css> = css`
    :root {
        ${redundantCssFromKebab("-fontfamilytext", `${FONT_FAMILY_TEXT}`)}
        ${redundantCssFromKebab("-fontfamilydisplay", `${FONT_FAMILY_DISPLAY}`)}
        ${redundantCssFromKebab("font-size", "16px")}
    }
    body {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.text}`)}
        ${redundantCssFromKebab("font-size", `${fontSizes.md}`)}
        ${redundantCssFromKebab("min-height", "100vh")}
        &.prevent-scroll {
            ${redundantCssFromKebab("overflow", "hidden")}
        }
    }
    .app-root {
        ${redundantCssFromKebab("min-height", "100vh")}
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("flex-direction", "column")}
        > div,
        > header,
        > main,
        > footer {
            ${redundantCssFromKebab("width", "100%")}
        }
        > :not(main) {
            ${redundantCssFromKebab("flex-grow", "0")}
            ${redundantCssFromKebab("flex-shrink", "0")}
        }
        > main {
            ${redundantCssFromKebab("flex-grow", "1")}
        }
    }
    // Reassign text font-family for certain languages
    // See: https://hello.atlassian.net/browse/BXPT-897
    html[lang="vi"] body {
        ${redundantCssFromKebab("-fontfamilytext", `${FONT_FAMILY_SYSTEM}`)}
    }
    h1,
    .h1 {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${h1}
    }
    h2,
    .h2 {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${h2}
    }
    h3,
    .h3 {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${h3}
    }
    h4,
    .h4 {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${h4}
    }
    h5,
    .h5 {
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.display}`)}
        ${h5}
    }
    h6,
    .h6 {
        ${h6}
    }
    p {
        ${redundantCssFromKebab("margin-block-end", "1.5rem")}
    }
    ul,
    ol {
        ${redundantCssFromKebab("margin-block-start", "0.5rem")}
        ${redundantCssFromKebab("margin-block-end", "1rem")}
        ${redundantCssFromKebab("padding-inline-start", "1.5rem")}
    }
    li {
        ${redundantCssFromKebab("margin-block-end", "0.25rem")}
    }
    li:last-child {
        ${redundantCssFromKebab("margin-block-end", "0")}
    }
    img {
        ${redundantCssFromKebab("max-width", "100%")}
        ${redundantCssFromKebab("height", "auto")}
    }
    a {
        ${redundantCssFromKebab("color", "rgba(0, 82, 204, 1)")}
        ${redundantCssFromKebab("text-decoration", "none")}
        &:hover {
            ${redundantCssFromKebab("text-decoration", "underline !important")}
        }
    }
    /* Light background containers should have blue links - but NOT in header */
    main [style*="background-color: rgb(255, 255, 255)"] a,
    main [style*="background-color: rgb(244, 245, 247)"] a,
    main [data-testid="block"] a {
        ${redundantCssFromKebab("color", "rgba(0, 82, 204, 1) !important")}
    }
    /* Header links inherit color from their respective styled-components */
    header a,
    header button {
        ${redundantCssFromKebab("color", "inherit")}
    }
`;
